export interface DashboardConfig {
  widgets: string[]
  links: string[]
}

export interface WidgetDef {
  id: string
  label: string
  permission: string | string[] | null
  category: 'kpi' | 'table' | 'calendar'
}

export interface LinkDef {
  id: string
  label: string
  route: string
  permission: string | string[] | null
}

export function checkPermission(
  permission: string | string[] | null,
  hasPermission: (p: string) => boolean
): boolean {
  if (permission === null) return true
  if (Array.isArray(permission)) return permission.some(hasPermission)
  return hasPermission(permission)
}

export const WIDGET_CATALOG: WidgetDef[] = [
  // ── KPI esistenti ───────────────────────────────────────────────────────────
  { id: 'kpi_stati',                  label: 'Stato OdL (barra KPI)',        permission: ['work_orders.view', 'work_orders.view_own'],           category: 'kpi' },
  { id: 'kpi_rda_senza_rdo',          label: 'RDA senza RDO',                permission: 'purchase_requests.view',     category: 'kpi' },
  { id: 'kpi_utenti_pending',         label: 'Utenti in attesa',             permission: 'system.manage_users',        category: 'kpi' },
  { id: 'kpi_manutenzioni_scadute',   label: 'Manutenzioni scadute',         permission: 'maintenance.view',           category: 'kpi' },
  { id: 'kpi_messaggi_non_letti',     label: 'Messaggi non letti',           permission: 'comunicazioni.view',         category: 'kpi' },
  // ── KPI nuovi ───────────────────────────────────────────────────────────────
  { id: 'kpi_wo_in_lavorazione',      label: 'OdL in lavorazione',           permission: ['work_orders.view', 'work_orders.view_own'],           category: 'kpi' },
  { id: 'kpi_wo_in_ritardo',          label: 'OdL in ritardo',               permission: ['work_orders.view', 'work_orders.view_own'],           category: 'kpi' },
  { id: 'kpi_wo_sinistri',            label: 'OdL sinistri aperti',          permission: ['work_orders.view', 'work_orders.view_own'],           category: 'kpi' },
  { id: 'kpi_rda_in_approvazione',    label: 'RDA in approvazione',          permission: 'purchase_requests.view',     category: 'kpi' },
  { id: 'kpi_rda_rifiutate',          label: 'RDA rifiutate',                permission: 'purchase_requests.view',     category: 'kpi' },
  { id: 'kpi_rda_da_ordinare',        label: 'RDA da ordinare',              permission: 'purchase_requests.view',     category: 'kpi' },
  { id: 'kpi_ordini_in_attesa',       label: 'Ordini in attesa',             permission: 'purchase_requests.view',     category: 'kpi' },
  { id: 'kpi_rdo_consegna_scaduta',   label: 'RDO consegna scaduta',         permission: 'purchase_requests.view',     category: 'kpi' },
  { id: 'kpi_auto_cortesia',          label: 'Auto cortesia disponibili',    permission: 'courtesy_cars.view',         category: 'kpi' },
  { id: 'kpi_prenotazioni_cambio',    label: 'Pren. cambio gomme (7gg)',     permission: 'tire_service.view',          category: 'kpi' },
  // ── Tabelle esistenti ───────────────────────────────────────────────────────
  { id: 'table_schede_stato',         label: 'Tabelle per stato OdL',        permission: ['work_orders.view', 'work_orders.view_own'],           category: 'table' },
  { id: 'table_ultimi_wo',            label: 'Ultimi OdL aperti',            permission: ['work_orders.view', 'work_orders.view_own'],           category: 'table' },
  { id: 'table_manutenzioni',         label: 'Manutenzioni in scadenza',     permission: 'maintenance.view',           category: 'table' },
  { id: 'table_ordini_recenti',       label: 'RDO attive',                   permission: 'purchase_requests.view',     category: 'table' },
  { id: 'table_rda_senza_rdo',        label: 'RDA senza RDO (lista)',        permission: 'purchase_requests.view',     category: 'table' },
  // ── Tabelle nuove ───────────────────────────────────────────────────────────
  { id: 'table_wo_bozze',             label: 'OdL in bozza',                 permission: ['work_orders.view', 'work_orders.view_own'],           category: 'table' },
  { id: 'table_wo_in_ritardo',        label: 'OdL in ritardo (lista)',       permission: ['work_orders.view', 'work_orders.view_own'],           category: 'table' },
  { id: 'table_wo_sinistri',          label: 'OdL sinistri (lista)',         permission: ['work_orders.view', 'work_orders.view_own'],           category: 'table' },
  { id: 'table_rda_in_approvazione',  label: 'RDA in approvazione (lista)',  permission: 'purchase_requests.view',     category: 'table' },
  { id: 'table_rda_rifiutate',        label: 'RDA rifiutate (lista)',        permission: 'purchase_requests.view',     category: 'table' },
  { id: 'table_rda_da_ordinare',      label: 'RDA da ordinare (lista)',      permission: 'purchase_requests.view',     category: 'table' },
  { id: 'table_ordini_in_attesa',     label: 'Ordini in attesa (lista)',     permission: 'purchase_requests.view',     category: 'table' },
  { id: 'table_rdo_consegna_scaduta', label: 'RDO consegna scaduta (lista)', permission: 'purchase_requests.view',     category: 'table' },
  { id: 'table_auto_cortesia',        label: 'Auto di cortesia disponibili', permission: 'courtesy_cars.view',         category: 'table' },
  { id: 'table_prenotazioni_cambio',  label: 'Prenotazioni cambio (7gg)',    permission: 'tire_service.view',          category: 'table' },
  // ── Calendario ──────────────────────────────────────────────────────────────
  { id: 'calendar_mini',              label: 'Agenda di oggi',               permission: 'calendar.view',              category: 'calendar' },
]

export const LINK_CATALOG: LinkDef[] = [
  { id: 'link_nuova_wo',         label: 'Nuova OdL',           route: '/schede-lavoro',         permission: ['work_orders.view', 'work_orders.view_own'] },
  { id: 'link_rda',              label: 'RDO (Offerte)',        route: '/rda',                   permission: 'purchase_requests.view' },
  { id: 'link_ricezione_ordini', label: 'Ricezione Ordini',    route: '/ordini',                permission: 'purchase_requests.receive' },
  { id: 'link_calendario',       label: 'Calendario',          route: '/calendar',              permission: 'calendar.view' },
  { id: 'link_gestione_utenti',  label: 'Gestione Utenti',     route: '/users',                 permission: 'system.manage_users' },
  { id: 'link_comunicazioni',    label: 'Comunicazioni',       route: '/comunicazioni',         permission: null },
  { id: 'link_manutenzioni',     label: 'Manutenzioni',        route: '/maintenance',           permission: 'maintenance.view' },
  { id: 'link_checkin_gomme',    label: 'Check-in Gomme',      route: '/tire-checkin',          permission: 'tire_service.checkin' },
  { id: 'link_dashboard_config', label: 'Impostazioni Profilo',route: '/profile',               permission: null },
]

export const ROLE_DEFAULTS: Record<string, DashboardConfig> = {
  ADMIN: {
    widgets: ['kpi_stati', 'kpi_utenti_pending', 'kpi_rda_senza_rdo', 'kpi_wo_in_ritardo', 'table_schede_stato', 'table_wo_in_ritardo'],
    links: ['link_nuova_wo', 'link_gestione_utenti', 'link_comunicazioni'],
  },
  GM: {
    widgets: [
      'kpi_stati', 'kpi_wo_in_lavorazione', 'kpi_wo_in_ritardo', 'kpi_wo_sinistri',
      'kpi_rda_in_approvazione', 'kpi_rda_rifiutate', 'kpi_rdo_consegna_scaduta',
      'table_schede_stato', 'table_rda_in_approvazione', 'table_wo_in_ritardo', 'table_wo_sinistri', 'table_rdo_consegna_scaduta',
    ],
    links: ['link_nuova_wo', 'link_rda', 'link_comunicazioni'],
  },
  GMA: {
    widgets: [
      'kpi_rda_senza_rdo', 'kpi_rda_da_ordinare', 'kpi_ordini_in_attesa', 'kpi_rdo_consegna_scaduta',
      'table_ultimi_wo', 'table_rda_da_ordinare', 'table_ordini_in_attesa', 'table_rda_senza_rdo', 'table_rdo_consegna_scaduta',
    ],
    links: ['link_nuova_wo', 'link_rda', 'link_ricezione_ordini'],
  },
  ACC: {
    widgets: ['kpi_stati', 'kpi_wo_in_lavorazione', 'kpi_messaggi_non_letti', 'table_ultimi_wo', 'table_wo_bozze', 'calendar_mini'],
    links: ['link_nuova_wo', 'link_calendario', 'link_comunicazioni'],
  },
  FEM: {
    widgets: ['kpi_stati', 'kpi_wo_in_lavorazione', 'kpi_messaggi_non_letti', 'table_ultimi_wo', 'calendar_mini'],
    links: ['link_nuova_wo', 'link_calendario', 'link_comunicazioni'],
  },
  CFM: {
    widgets: [
      'kpi_rda_senza_rdo', 'kpi_rda_da_ordinare', 'kpi_ordini_in_attesa', 'kpi_rdo_consegna_scaduta',
      'table_ordini_recenti', 'table_rda_senza_rdo', 'table_rda_da_ordinare', 'table_ordini_in_attesa', 'table_rdo_consegna_scaduta',
    ],
    links: ['link_rda', 'link_ricezione_ordini'],
  },
  CMM: {
    widgets: [
      'kpi_stati', 'kpi_rda_senza_rdo', 'kpi_manutenzioni_scadute', 'kpi_auto_cortesia',
      'table_schede_stato', 'table_manutenzioni', 'table_auto_cortesia',
    ],
    links: ['link_nuova_wo', 'link_rda', 'link_manutenzioni'],
  },
  CBM: {
    widgets: ['kpi_stati', 'kpi_wo_sinistri', 'kpi_rda_senza_rdo', 'table_schede_stato', 'table_wo_sinistri'],
    links: ['link_nuova_wo', 'link_rda'],
  },
  WORKSHOP: {
    widgets: ['kpi_stati', 'kpi_wo_in_lavorazione', 'kpi_prenotazioni_cambio', 'table_ultimi_wo', 'table_prenotazioni_cambio'],
    links: ['link_nuova_wo', 'link_checkin_gomme'],
  },
  BODYSHOP: {
    widgets: ['kpi_stati', 'kpi_wo_in_lavorazione', 'table_ultimi_wo'],
    links: ['link_nuova_wo'],
  },
}
